import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import { useSelector } from "react-redux";

import { Box, TextField, Typography } from "@mui/material";

import {
  consultaActiDependiente,
  crearClienteActiDependiente,
} from "../services/clienteService";

import { formatoFecha } from "app/modules/shared/validations/validaciones";
import SpinnerLoadSrx from "app/modules/shared/components/SpinnerLoadSrx";
import AcceptServiceresponse from "app/modules/shared/components/AcceptServiceresponse";

import { SCSLoadingButton } from "app/modules/common/components/Buttons/SCSButtons";
import SCSAccordion from "app/modules/common/components/Accordions/SCSAccordion";
import { StyleInputs } from "../styles/themes";

import "../styles/main.css";

const FormClienteActividadDependiente = ({
  idCliente,
  setInfoClienteGrabada,
}) => {
  const { authUser } = useSelector(({ auth }) => auth);

  const [clienteInfo, setClienteInfo] = useState({});
  const [isloading, setIsLoading] = useState(true);
  const [datosEnviadosCorrectamente, setDatosEnviadosCorrectamente] =
    useState(false);
  const [idActiDependienteAux, setIdActiDependienteAux] = useState(0);

  useEffect(() => {
    const getData = async () => {
      try {
        const infoActiDependienteAux = await consultaActiDependiente(idCliente);

        if (infoActiDependienteAux.state) {
          setIdActiDependienteAux(
            infoActiDependienteAux.data.idActividadDependiente
          );

          setClienteInfo(infoActiDependienteAux.data);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setClienteInfo({});
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    };
    getData();
  }, []);

  if (isloading) {
    return <SpinnerLoadSrx />;
  }

  const configuracionDatosEnvio = async (valores, setSubmitting) => {
    setSubmitting(true);

    const today = new Date().toLocaleString("en-US");
    const informacionActiDependiente = {
      idCliente: idCliente,
      idActividadDependiente: idActiDependienteAux,

      nombreEmpresa: valores.nombreEmpresa.toUpperCase(),
      fechaInicio: valores.fechaInicio,
      esActivo: true,

      fechaCreacion: today,
      usuarioCreacion: authUser.key,
      estacionCreacion: authUser.estacion,
    };

    try {
      const respuestaActiDependiente = await crearClienteActiDependiente(
        informacionActiDependiente
      );

      if (respuestaActiDependiente.state) {
        setDatosEnviadosCorrectamente(true);
        setIdActiDependienteAux(respuestaActiDependiente.data);

        if (setInfoClienteGrabada) {
          setInfoClienteGrabada((args) => ({
            ...args,
            financiero: true,
          }));
        }

        setTimeout(() => {
          setSubmitting(false);
          setDatosEnviadosCorrectamente(false);
        }, 1000);
      } else {
        setSubmitting(false);
        alert(`${respuestaActiDependiente.data.message}`);
      }
    } catch (error) {
      setSubmitting(false);
      alert(`${error.response.data.message}`);
      console.log(error);
    } finally {
      setSubmitting(false);
    }
  };

  const InfoDependiente = ({}) => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: 1,
          p: 1,
          width: "100%",
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          Si eres empleado
        </Typography>

        <Typography variant="body2" color="text.secondary">
          Cuéntanos en qué empresa trabajas y desde cuándo formas parte de ella.
        </Typography>
      </Box>
    );
  };

  return (
    <Formik
      initialValues={{
        nombreEmpresa: clienteInfo.nombreEmpresa || "",
        fechaInicio: clienteInfo.fechaInicio ?? "",
      }}
      validationSchema={Yup.object({
        nombreEmpresa: Yup.string().required("Nombre Empresa requerido"),
        fechaInicio: Yup.string().required("Fecha inicio requerido"),
      })}
      onSubmit={(values, { setSubmitting }) => {
        configuracionDatosEnvio(values, setSubmitting);
      }}
    >
      {({
        values,
        handleChange,
        touched,
        errors,
        handleBlur,
        isSubmitting,
      }) => (
        <Form>
          <SCSAccordion
            tituloCabecera="Actividad Dependiente"
            tieneInfo={true}
            componenteInformacion={<InfoDependiente />}
          >
            <div className="cliente-informacion-seccion">
              <div style={{ marginRight: 90 }}>
                <h3>Detalle Empresa</h3>
              </div>

              <TextField
                id="nombreEmpresa"
                name="nombreEmpresa"
                type="text"
                label="Nombre Empresa"
                sx={StyleInputs(20, 45)}
                value={values.nombreEmpresa}
                onChange={handleChange}
                size="small"
                inputProps={{
                  style: { textTransform: "uppercase" },
                }}
                error={touched.nombreEmpresa && Boolean(errors.nombreEmpresa)}
                helperText={touched.nombreEmpresa && errors.nombreEmpresa}
                onBlur={handleBlur}
              />

              <TextField
                id="fechaInicio"
                label="Fecha de Inicio"
                type="date"
                size="small"
                sx={StyleInputs(25, 47)}
                onChange={handleChange}
                value={formatoFecha(values.fechaInicio)}
                InputLabelProps={{
                  shrink: true,
                }}
                error={touched.fechaInicio && Boolean(errors.fechaInicio)}
                helperText={touched.fechaInicio && errors.fechaInicio}
                onBlur={handleBlur}
              />
            </div>

            <div className="confirmar-estados-servicios">
              <SCSLoadingButton loading={isSubmitting} titulo="GUARDAR" />

              {datosEnviadosCorrectamente && <AcceptServiceresponse />}
            </div>
          </SCSAccordion>
        </Form>
      )}
    </Formik>
  );
};

export default FormClienteActividadDependiente;
